export default __webpack_public_path__ + "static/media/mars.2bc9307c.png";